<template>
    <div class="col-md-12 mx-auto">
        <div class="card mt-12">
            <dashboard-ctrl :componentName="componentName"
                            :showHideButton="showHideButton"
                            :showPinButton="showPinButton"
                            :showResizeIcon="showResizeIcon"
                            :size="size"
                            :headerTitle="titleKey"
                            :componentClass="'card-header bg-primary text-white'"
                            :showHeadful="showHeadful"
                            @hide="hide"
                            @resize="resize"
                            @pinned="pinned"
                            @unpinned="unpinned">
            </dashboard-ctrl>

            <div class="btn-toolbar justify-content-between mb-0 mt-2" role="toolbar">
                <div class="col-w">

                </div>
                <div class="input-group">
                    <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary"
                            @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>

            <div class="card-body pt-1">
                <app-popup ref="appPopup" :fullscreen="true"></app-popup>

                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError">
                </kendo-datasource>

                <kendo-grid ref="grid"
                            :data-source-ref="'datasource1'"
                            :navigatable="gridOptions.navigatable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :editable="false"
                            :excel="gridOptions.excel"
                            :toolbar="gridOptions.toolbar"
                            :data-bound="dataBound">
                    <kendo-grid-column field="id"
                                       :hidden="!claims.audit.read"
                                       :title="$t('account.audit.gridHeaders.id')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column field="username"
                                       :title="$t('account.audit.gridHeaders.userName')">
                    </kendo-grid-column>
                    <kendo-grid-column field="actionName"
                                       :title="$t('account.audit.gridHeaders.actionName')">
                    </kendo-grid-column>
                    <kendo-grid-column field="controllerName"
                                       :title="$t('account.audit.gridHeaders.controllerName')">
                    </kendo-grid-column>
                    <kendo-grid-column field="activity"
                                       :title="$t('account.audit.gridHeaders.activity')">
                    </kendo-grid-column>
                    <kendo-grid-column field="ipAddress"
                                       :title="$t('account.audit.gridHeaders.ipAddress')">
                    </kendo-grid-column>
                    <kendo-grid-column field="duration"
                                       :title="$t('account.audit.gridHeaders.duration')">
                    </kendo-grid-column>
                    <kendo-grid-column field="timeAccessedUtc"
                                       :format="customDateFormat"
                                       :title="$t('account.audit.gridHeaders.timeAccessed')">
                    </kendo-grid-column>
                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :title="$t('actions')"
                                       v-if="showBtns"
                                       :width="150">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import { mapGetters } from 'vuex'
    import bus from '@/components/sidemenu/event-bus';

    import ControlBtnsTemplate from "@/components/dashboard/ControlBtnsTemplate";
    import BtnsTemplate from "@/components/grid/StandardBtnsTemplate";
    import MsgPopup from "@/components/common/MsgPopup.vue";

    export default {
        components: {
            'app-popup': MsgPopup,
            'dashboard-ctrl': ControlBtnsTemplate,
        },
        props: {
            // Пропъртита, които трабват на компонента с бутоните за дашборд настройките
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            all: {
                type: Boolean,
                default: false
            },
            showHeadful: {
                default: true,
                type: Boolean
            },
        },
        data() {
            return {
                componentName: "auditregister", // Used from dashboard controll. Have to be the same as the component name
                titleKey: 'account.auditlogs',
                searchQuery: '',
                defaultGridRows: this.$store.getters.defaultGridRows,
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: true, visible: true },
                    username: { name: 'username', type: 'string', editable: false, nullable: true, visible: true },
                    actionName: { name: 'actionName', type: 'string', editable: false, nullable: true, visible: true },
                    controllerName: { name: 'controllerName', type: 'string', editable: false, nullable: true, visible: true },
                    activity: { name: 'activity', type: 'string', editable: false, nullable: true, visible: true },
                    ipAddress: { name: 'ipAddress', type: 'string', editable: false, nullable: true, visible: true },
                    duration: { name: 'duration', type: "number", editable: false, nullable: true, visible: true },
                    timeAccessedUtc: { name: 'timeAccessedUtc', type: 'date', visible: true },
                    formatedTimeUtc: { name: 'formatedTimeUtc', type: 'string', editable: false, nullable: true, visible: true },
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/audit/${(this.all ? 'all' : 'my')}`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                }
            };
        },
        methods: {
            dataBound(e) {

            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                })
            },
            parameterMap(options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    return kendo.stringify(options);
                }
            },
            btnsTemplate(e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [{
                            name: "details",
                            text: "",
                            tooltip: this.$t('details'),
                            class: 'btn btn-info',
                            icon: "fas fa-eye",
                            show: true,
                            clickHandler: this.showDetails
                        }, {
                            name: "validation",
                            text: "",
                            tooltip: this.$t('audit.validation'),
                            class: 'btn btn-success',
                            icon: "fas fa-check",
                            show: true,
                            clickHandler: this.validate
                        },
                        {
                            name: "chain-validation",
                            text: "",
                            tooltip: this.$t('audit.chainValidation'),
                            class: 'btn btn-success',
                            icon: "fas fa-link",
                            show: true,
                            clickHandler: this.validateChain
                        }]
                    }
                };
            },
            beforeSend(req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            showDetails(args) {
                this.$http.get('/api/audit/' + args.id)
                    .then(response => {
                        var content = this.getDetailsText(response.data)
                        this.$refs.appPopup.show('success', this.$t('details'), content);
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('details'),
                            text: this.$helpers.errorText(error),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    });
            },
            getDetailsText(data) {
                return "<div class=\"form-group\">"
                    + "<label for=\"username\" class=\"h5\">" + this.$t('account.audit.gridHeaders.userName') + "</label>"
                    + "<input type=\"text\" readonly class=\"form-control-plaintext\" id=\"username\" value=\"" + data.username + "\">"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"actionName\" class=\"h5\">" + this.$t('account.audit.gridHeaders.actionName') + "</label>"
                    + "<input type=\"text\" readonly class=\"form-control-plaintext\" id=\"actionName\" value=\"" + data.actionName + "\">"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"controllerName\" class=\"h5\">" + this.$t('account.audit.gridHeaders.controllerName') + "</label>"
                    + "<input type=\"text\" readonly class=\"form-control-plaintext\" id=\"controllerName\" value=\"" + data.controllerName + "\">"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"requestMethod\" class=\"h5\">" + this.$t('account.audit.gridHeaders.requestMethod') + "</label>"
                    + "<input type=\"text\" readonly class=\"form-control-plaintext\" id=\"requestMethod\" value=\"" + data.requestMethod + "\">"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"urlAccessed\" class=\"h5\">" + this.$t('account.audit.gridHeaders.urlAccessed') + "</label>"
                    + "<input type=\"text\" readonly class=\"form-control-plaintext\" id=\"urlAccessed\" value=\"" + data.urlAccessed + "\">"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"activity\" class=\"h5\">" + this.$t('account.audit.gridHeaders.activity') + "</label>"
                    + "<input type=\"text\" readonly class=\"form-control-plaintext\" id=\"activity\" value=\"" + data.activity + "\">"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"ipAddress\" class=\"h5\">" + this.$t('account.audit.gridHeaders.ipAddress') + "</label>"
                    + "<input type=\"text\" readonly class=\"form-control-plaintext\" id=\"ipAddress\" value=\"" + data.ipAddress + "\">"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"sessionId\" class=\"h5\">" + this.$t('account.audit.gridHeaders.sessionId') + "</label>"
                    + "<input type=\"text\" readonly class=\"form-control-plaintext\" id=\"sessionId\" value=\"" + data.sessionId + "\">"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"duration\" class=\"h5\">" + this.$t('account.audit.gridHeaders.duration') + "</label>"
                    + "<input type=\"text\" readonly class=\"form-control-plaintext\" id=\"duration\" value=\"" + data.duration + "\">"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"formatedTimeUtc\" class=\"h5\">" + this.$t('account.audit.gridHeaders.formatedTimeUtc') + "</label>"
                    + "<input type=\"text\" readonly class=\"form-control-plaintext\" id=\"formatedTimeUtc\" value=\"" + data.formatedTimeUtc + "\">"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"auditTypeStr\" class=\"h5\">" + this.$t('account.audit.gridHeaders.auditTypeStr') + "</label>"
                    + "<input type=\"text\" readonly class=\"form-control-plaintext\" id=\"auditTypeStr\" value=\"" + data.auditTypeStr + "\">"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"hash\" class=\"h5\">" + this.$t('account.audit.gridHeaders.hash') + "</label>"
                    + "<textarea readonly class=\"form-control-plaintext\" id=\"hash\" rows=\"3\">" + data.hash + "</textarea>"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"data\" class=\"h5\">" + this.$t('account.audit.gridHeaders.data') + "</label>"
                    + "<textarea readonly class=\"form-control-plaintext\" id=\"data\" rows=\"3\">" + data.data + "</textarea>"
                    + "</div>"
                    + "<div class=\"form-group\">"
                    + "<label for=\"additionalData\" class=\"h5\">" + this.$t('account.audit.gridHeaders.additionalData') + "</label>"
                    + "<textarea readonly class=\"form-control-plaintext\" id=\"additionalData\" rows=\"3\">" + data.additionalData + "</textarea>"
                    + "</div>"
            },
            validate(args) {
                this.doAuditValidation(args.id, false);
            },
            validateChain(args) {
                this.doAuditValidation(args.id, true);
            },
            doAuditValidation(id, isChain) {
                this.$http.get('/api/audit/' + id + '/validate/' + isChain)
                    .then(response => {
                        this.$refs.appPopup.show(response.data.isValid === true ? 'success' : "danger",
                            isChain === true ? this.$t('audit.chainValidation') : this.$t('audit.validation'),
                            '<div class="text-center">' + response.data.msg + '</div>', true);
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            resize(componentName, size) {
                this.$emit('resize', componentName, size)
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            hide(componentName) {
                this.$emit('hide', componentName)
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            pinned(componentName) {
                this.$emit('pinned', componentName)
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            unpinned(componentName) {
                this.$emit('unpinned', componentName)
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            refresh() {
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            onActionLogCreate(userId) {
                if (this.all) {
                    this.refresh();
                } else {
                    if (userId && this.currentUserId === userId) {
                        this.refresh();
                    }
                }
            }
        },
        mounted() {

        },
        created() {
            window.JSZip = JSZip
            this.bus = bus;

            this.bus.$on('action-log-create', this.onActionLogCreate);
        },
        beforeDestroy() {
            // Make sure to cleanup SignalR event handlers when removing the component
            this.bus.$off('action-log-create', this.onActionLogCreate);
        },
        computed: {
            ...mapGetters(['claims', 'authToken', 'dateTimeLongFormat', 'userId']),
            token() {
                return this.authToken;
            },
            customDateFormat() {
                return `{0:${this.dateTimeLongFormat}}`
            },
            currentUserId() {
                return this.userId;
            },
            gridOptions() {
                return {
                    ...this.$store.getters.gridOptions,
                    toolbar: ['excel'],
                    excel: {
                        fileName: `${this.$t(this.titleKey)}.xlsx`,
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    }
                };
            },
        }
    }
</script>

<style scoped>
</style>
